export const EDIT_USER_TITLE = "Editar Usuário";
export const ROLE_LABEL = "Perfil";
export const ROLE_PLACEHOLDER = "Selecione";
export const ROLE_SEARCH_PLACEHOLDER = "Buscar perfil";
export const ROLES_ERROR_MESSAGE = "Não foi possível carregar os perfis.";
export const ROLES_EMPTY_MESSAGE = "Nenhum perfil cadastrado.";
export const ROLES_EMPTY_FILTER_MESSAGE = "Nenhum perfil encontrado.";

/** Liga o botão Salvar, que vive no rodapé do Dialog, ao formulário do corpo. */
export const EDIT_USER_FORM_ID = "edit-user-form";
